import { React, useEffect, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/ArrowForwardIos";
import MDTypography from "components/MDTypography";
import { TextField } from "@mui/material";
import PropTypes from "prop-types";

function MultiSelectTreeView(props) {
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    // Toggle Nav
    const toggler = document.getElementsByClassName("caret");

    // Convert HTMLCollection to an array
    const togglerArray = Array.from(toggler);

    for (const element of togglerArray) {
      element.addEventListener("click", function (event) {
        const nested =
          event.currentTarget.parentElement.querySelector(".nested");
        if (nested) {
          // Check if nested is not null
          nested.classList.toggle("active");
        }
        event.currentTarget.classList.toggle("caret-down");
      });
    }
  }, []);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    props.searchedData(e.target.value);
  };

  return (
    <>
      <TextField
        className="outlined-basic-subject search-doc my-2"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleInputChange}
        autoComplete="off"
      />
      <MDTypography
        variant="p"
        fontSize="13px"
        fontWeight="regular"
        fontFamily="inherit"
        color="white"
      >
        <ul className="docs-nav">
          <li>
            <a href="#introduction">
              <MDTypography
                variant="h6"
                fontSize="13px"
                fontWeight="regular"
                fontFamily="inherit"
              >
                <div data-to-scrollspy-id="introduction">Introduction</div>
              </MDTypography>
            </a>
          </li>
          <li>
            <a href="#the-function-external-api">
              <MDTypography
                variant="h6"
                fontSize="13px"
                fontWeight="regular"
                fontFamily="inherit"
              >
                <div data-to-scrollspy-id="the-function-external-api">
                  The Function of External API
                </div>
              </MDTypography>
            </a>
          </li>
          <li>
            <a href="#environment">
              <MDTypography
                variant="h6"
                fontSize="13px"
                fontWeight="regular"
                fontFamily="inherit"
              >
                <div data-to-scrollspy-id="environment">Environment</div>
              </MDTypography>
            </a>
          </li>
          <li>
            <span className="caret">
              <a href="#authorization">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="authorization">
                    Authorization
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </a>
            </span>
            <ul className="nested">
              <li>
                <a href="#get-access-token-request-endpoint">
                  <span className="caret">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      <div data-to-scrollspy-id="get-access-token-request-endpoint">
                        Request Endpoint
                      </div>
                    </MDTypography>
                  </span>
                </a>
              </li>
              <li>
                <a href="#get-access-token-request-body">
                  <span className="caret">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      <div data-to-scrollspy-id="get-access-token-request-endpoint">
                        Request Body
                      </div>
                    </MDTypography>
                  </span>
                </a>
              </li>
            </ul>
          </li>
          <li>
            <span className="caret">
              <a href="#post-fund-request">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="post-fund-request">
                    POST Fund Request
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </a>
            </span>
            <ul className="nested">
              <li>
                <a href="#post-fund-request-endpoint">
                  <span className="caret">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      Request Endpoint
                    </MDTypography>
                  </span>
                </a>
              </li>
              <li>
                <a href="#post-fund-request-headers">
                  <span className="caret">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      Request Headers
                    </MDTypography>
                  </span>
                </a>
              </li>
              <li>
                <a href="#post-fund-request-body">
                  <span className="caret">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      Request Body
                    </MDTypography>
                  </span>
                </a>
              </li>
              <li>
                <a href="#post-fund-response-body">
                  <span className="caret">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      Response Body
                    </MDTypography>
                  </span>
                </a>
              </li>
            </ul>
          </li>
          <li>
            <span className="caret">
              <a href="#external-api-fund-request">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="external-api-fund-request">
                    External API Fund Request
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </a>
            </span>
            <ul className="nested">
              <li>
                <a href="#external-api-fund-request-endpoint">
                  <span className="caret">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      Request Endpoint
                    </MDTypography>
                  </span>
                </a>
              </li>
              <li>
                <a href="#get-access-to-external-request-headers">
                  <span className="caret">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      Request Headers
                    </MDTypography>
                  </span>
                </a>
              </li>
              <li>
                <a href="#get-access-to-external-response-body">
                  <span className="caret">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      Response Body
                    </MDTypography>
                  </span>
                </a>
              </li>
            </ul>
          </li>
          <li>
            <span className="caret">
              <a href="#get-fund-req-details">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="get-fund-req-details">
                    GET Fund Request Details
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </a>
            </span>
            <ul className="nested">
              <li>
                <a href="#get-fund-request-details-endpoint">
                  <span className="caret">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      Request Endpoint
                    </MDTypography>
                  </span>
                </a>
              </li>
              <li>
                <a href="#get-fund-request-details-req-headers">
                  <span className="caret">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      Request Headers
                    </MDTypography>
                  </span>
                </a>
              </li>
              <li>
                <a href="#get-fund-request-details-req-body">
                  <span className="caret">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      Request Body
                    </MDTypography>
                  </span>
                </a>
              </li>
            </ul>
          </li>
          <li>
            <span className="caret">
              <a href="#get-all-fund-req">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="get-all-fund-req">
                    GET All Fund Requests
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </a>
            </span>
            {/* <ul className="nested">
                            <li><a href="#get-all-fund-request-endpoint"><span className="caret"><MDTypography variant="h6" fontSize="13px" fontWeight="regular" fontFamily="inherit">Request Endpoint</MDTypography></span></a></li>
                            <li><a href="#get-all-fund-request-headers"><span className="caret"><MDTypography variant="h6" fontSize="13px" fontWeight="regular" fontFamily="inherit">Request Headers</MDTypography></span></a></li>
                            <li><a href="#get-all-fund-request-body"><span className="caret"><MDTypography variant="h6" fontSize="13px" fontWeight="regular" fontFamily="inherit">Request Body</MDTypography></span></a></li>
                        </ul> */}
            <ul className="nested">
              <li>
                <span className="caret">
                  <a href="#get-all">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      <div data-to-scrollspy-id="get-all">
                        Get All
                        <KeyboardArrowRightIcon />
                      </div>
                    </MDTypography>
                  </a>
                </span>
                <ul className="nested">
                  <li>
                    <a href="#get-all-endpoint">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Request Endpoint
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#get-all-headers">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Request Headers
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#get-all-req-body">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Request Body
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <span className="caret">
                  <a href="#get-specific-fund-req">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      <div data-to-scrollspy-id="get-specific-fund-req">
                        Get Specific Fund Request
                        <KeyboardArrowRightIcon />
                      </div>
                    </MDTypography>
                  </a>
                </span>
                <ul className="nested">
                  <li>
                    <a href="#get-specific-fund-req-endpoint">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Request Endpoint
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#get-specific-fund-req-headers">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Request Headers
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#get-specific-fund-req-body">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Request Body
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <span className="caret">
                  <a href="#get-all-banking-instruction">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      <div data-to-scrollspy-id="get-all-banking-instruction">
                        Get All Banking Instruction
                        <KeyboardArrowRightIcon />
                      </div>
                    </MDTypography>
                  </a>
                </span>
                <ul className="nested">
                  <li>
                    <a href="#get-all-banking-instruction-endpoint">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Request Endpoint
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#get-all-banking-instruction-req-headers">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Request Headers
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#get-all-banking-instruction-req-body">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Request Body
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <span className="caret">
                  <a href="#get-all-audit-trails">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      <div data-to-scrollspy-id="get-all-audit-trails">
                        Get All Audit Trails
                        <KeyboardArrowRightIcon />
                      </div>
                    </MDTypography>
                  </a>
                </span>
                <ul className="nested">
                  <li>
                    <a href="#get-all-audit-trails-endpoint">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Request Endpoint
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#get-all-audit-trails-headers">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Request Headers
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#get-all-audit-trails-body">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Request Body
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <span className="caret">
                  <a href="#get-all-audit-trails-by-date">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      <div data-to-scrollspy-id="get-all-audit-trails-by-date">
                        Get All Audit Trails By Date
                        <KeyboardArrowRightIcon />
                      </div>
                    </MDTypography>
                  </a>
                </span>
                <ul className="nested">
                  <li>
                    <a href="#get-all-audit-trails-by-date-endpoint">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          <div data-to-scrollspy-id="get-all-audit-trails-by-date-endpoint">
                            Request Endpoint
                          </div>
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#get-all-audit-trails-by-date-headers">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          <div data-to-scrollspy-id="get-all-audit-trails-by-date-headers">
                            Request Headers
                          </div>
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#get-all-audit-trails-by-date-body">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          <div data-to-scrollspy-id="get-all-audit-trails-by-date-body">
                            Request Body
                          </div>
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <a href="#disclaimer">
              <MDTypography
                variant="h6"
                fontSize="13px"
                fontWeight="regular"
                fontFamily="inherit"
              >
                <div data-to-scrollspy-id="disclaimer">
                  Disclaimer and Confidentiality Notice{" "}
                </div>
              </MDTypography>
            </a>
          </li>
        </ul>
      </MDTypography>
    </>
  );
}
MultiSelectTreeView.propTypes = {
  searchedData: PropTypes.func.isRequired, // Assuming searchedData is a function
};
export default MultiSelectTreeView;
